import Vue from "vue";
import Router from "vue-router";
import Login from "../views/Login.vue";
import Dashboard from "../views/Dashboard.vue";
import Onboarding from "../views/Onboarding.vue";
import OnboardingCreate from "../views/OnboardingCreate.vue";
import OnboardingSubMerchantApply from "../views/OnboardingSubMerchantApply.vue";
import OnboardingWechatSubMerchantApply from "../views/OnboardingWechatSubMerchantApply.vue";
import OnboardingSubMerchantList from "../views/OnboardingSubMerchantList.vue";
import Orders from "../views/Orders.vue";
import Finance from "../views/Finance.vue";
import Agents from "../views/Agents.vue";
import Settings from "../views/Settings.vue";
import ApiDocument from "../views/ApiDocument.vue";
import UserRecords from "../views/UserRecords.vue";

Vue.use(Router);

export default new Router({
  mode: "hash",
  routes: [
    { path: "/", redirect: "/dashboard" },
    { path: "/login", component: Login },
    { path: "/dashboard", component: Dashboard },
    { path: "/onboarding", component: Onboarding },
    { path: "/onboarding/create", component: OnboardingCreate },
    { path: "/onboarding/submerchant-apply", component: OnboardingSubMerchantApply },
    { path: "/onboarding/wechat-submerchant-apply", component: OnboardingWechatSubMerchantApply },
    { path: "/onboarding/submerchant-list", component: OnboardingSubMerchantList },
    { path: "/orders", component: Orders },
    { path: "/finance", component: Finance },
    { path: "/agents", component: Agents },
    { path: "/user-records", component: UserRecords },
    { path: "/settings", component: Settings },
    { path: "/api-document", component: ApiDocument }
  ]
});
